// JavaScript Document
(function (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

    recalc = function () {
      var clientWidth = docEl.clientWidth; //获取设备尺寸
      var shejiWidth = 375; //设计稿的宽度
      if(clientWidth<600){
        docEl.style.fontSize = 100 * (clientWidth / shejiWidth) + 'px';
      };
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false); //绑定事件
  doc.addEventListener('DOMContentLoaded', recalc, false);

})(document, window);



// WEBPACK FOOTER //
// ./src/assets/rem.js